import { useCallback, useState } from 'react';

export type OpenState<TContext extends Record<string, unknown>> = {
  open: boolean;
  context: TContext;
};

export const useOpenState = <TContext extends Record<string, unknown>>(
  initialContext: TContext,
) => {
  const [state, setState] = useState<OpenState<TContext>>({
    open: false,
    context: initialContext,
  });

  const open = useCallback((context?: TContext) => {
    setState((state) => ({
      open: true,
      context: context
        ? { ...context }
        : {
            ...state.context,
          },
    }));
  }, []);

  const toggleOpen = useCallback((open: boolean) => {
    setState((state) => ({
      ...state,
      open,
    }));
  }, []);

  return {
    state,
    open,
    toggleOpen,
  };
};
